import React, { useState, useEffect } from "react";
import {
  CircularProgress,
  Divider,
  makeStyles,
  Typography,
  Popper,
  Box,
  Button,
} from "@material-ui/core";
import { useHistory } from "react-router-dom";
import { useLazyQuery } from "@apollo/react-hooks";
import gql from "graphql-tag";

import { useAlert } from "../../components/Alert";
import Grid from "../../components/Grid";
import Table from "../../components/Table";
import { CardContent } from "../../components/Card";
import moment from "moment";

const GET_FORECLOSURE = gql`
  query foreclosure($obj_no: Int!) {
    foreclosure(obj_no: $obj_no) {
      obj_no
      obj_court
      obj_str
      obj_share
      obj_caseno
      obj_another
      obj_time
      obj_date_ymd
      obj_date_hi
      obj_city
      obj_area
      obj_section
      obj_section_s
      obj_landno
      obj_address
      obj_link
      obj_margin
      obj_price
      obj_price_set
      obj_creditor
      obj_debtor
      obj_bulletin_data
      obj_remark
      obj_land_data
      obj_build_data
      obj_land_floor
      obj_build_floor
      obj_add_floor
      obj_s_floor
      obj_c_floor
      obj_total_floor
      obj_transfer
      obj_type
      obj_creat_date
      obj_stop
      obj_tender_num
      obj_tender
      obj_check_num
      obj_stop_link
      obj_source
      obj_marker
      obj_coordinates
      obj_request_num
      obj_cadastral
      obj_patterns
      obj_sql
      obj_pyPDF
      phppdfjoin
    }
  }
`;

export default function CurrentPopper({ data, onClose = () => {} }) {
  const history = useHistory();
  const Alert = useAlert();
  const [currentData, setCurrentData] = useState([]);
  const useStyles = makeStyles((theme) => ({
    paper: {
      border: "1px solid",
      padding: theme.spacing(1),
      backgroundColor: theme.palette.background.paper,
    },
  }));
  const classes = useStyles();
  const [
    getForeclosure,
    { data: foreclosureData, loading: foreclosureLoading },
  ] = useLazyQuery(GET_FORECLOSURE, {
    fetchPolicy: "network-only",
    notifyOnNetworkStatusChange: true,
    onCompleted({ foreclosure }) {
      if (foreclosure) {
        let newData = [];
        newData.push({
          obj_type: foreclosure.obj_type,
          obj_date_ymd: foreclosure.obj_date_ymd,
          obj_date_hi: foreclosure.obj_date_hi,
          obj_time: foreclosure.obj_time,
          obj_total_floor: foreclosure.obj_total_floor,
          obj_land_floor: foreclosure.obj_land_floor,
          obj_build_floor: foreclosure.obj_build_floor,
          obj_s_floor: foreclosure.obj_s_floor,
          obj_add_floor: foreclosure.obj_add_floor,
          obj_c_floor: foreclosure.obj_c_floor,
          obj_margin: foreclosure.obj_margin,
          obj_price: foreclosure.obj_price,
        });
        setCurrentData(newData);
      }
    },
    onError(error) {
      Alert.alert("通知", `${error}`, [
        {
          text: "確定",
          type: "ok",
        },
      ]);
    },
  });

  useEffect(() => {
    if (!!data.no)
      getForeclosure({
        variables: {
          obj_no: data.no,
        },
      });
  }, [data.no]);

  if (foreclosureLoading) {
    return (
      <Grid container item justify="center">
        <CircularProgress color="secondary" />
      </Grid>
    );
  } else {
    return (
      <Popper
        id="mouse-over-popover"
        open={data.open}
        anchorEl={data.anchorEl}
        placement="buttom"
        disablePortal={false}
        style={{ maxHeight: 500, maxWidth: 500, zIndex: 1000 }}
        onMouseLeave={onClose}
        modifiers={{
          flip: {
            enabled: true,
          },
          preventOverflow: {
            enabled: true,
            rootBoundary: "document",
            boundariesElement: "scrollParent",
          },
        }}
      >
        <Grid container className={classes.paper}>
          <Grid container spacing={1}>
            <Grid item>
              <Button
                variant="contained"
                color="primary"
                onClick={(e) => {
                  e.stopPropagation();
                  history.push(`/console/sale-obj-search-results/${data.no}`, {
                    id: data.no,
                  });
                }}
              >
                打開物件詳細資料
              </Button>
            </Grid>
            <Grid item>
              <Button
                variant="contained"
                color="primary"
                onClick={(e) => {
                  e.stopPropagation();
                  window.open(
                    `https://www.google.com/search?q=${data.debtor}`,
                    "_blank",
                    "noopener"
                  );
                }}
              >
                搜尋債務人
              </Button>
            </Grid>
          </Grid>
          <Grid
            container
            style={{ maxHeight: 500, maxWidth: 500, overflow: "auto" }}
          >
            <Table
              data={currentData ? currentData : []}
              tableWidth={2}
              header={[
                "投標日",
                "拍次",
                "總建坪",
                "地坪",
                "主建坪",
                "附建坪",
                "增建坪",
                "公設坪",
                "公告現值",
                "保證金",
                "底價",
              ]}
              columns={[
                (item) =>
                  moment(item.obj_date_ymd).format("YYYY-MM-DD") +
                  "\n" +
                  moment(item.obj_date_hi).format("HH:mm"),
                (item) => item.obj_time,
                (item) => (item.obj_type === "L" ? 0 : item.obj_total_floor),
                (item) => item.obj_land_floor,
                (item) => item.obj_build_floor,
                (item) => item.obj_s_floor,
                (item) => item.obj_add_floor,
                (item) => item.obj_c_floor,
                (item) => "公告現值",
                (item) => (item.obj_margin / 10000).toFixed(2) + "萬",
                (item) => item.obj_price + "萬",
              ]}
            />
            <Divider />
            {foreclosureData?.foreclosure && (
              <>
                <CardContent>
                  <Grid container spacing={1}>
                    <Box display="flex" alignItems="center" direction="row">
                      <Box minWidth={100} maxWidth="100px">
                        <Typography>土地</Typography>
                        <Typography style={{ color: "#3d5afe" }}>
                          {foreclosureData.foreclosure.obj_land_floor === 0
                            ? "建坪:" + 0
                            : "建坪:" +
                              (
                                foreclosureData.foreclosure.obj_price /
                                foreclosureData.foreclosure.obj_land_floor
                              ).toFixed(2) +
                              "萬" +
                              "\n"}
                        </Typography>
                        <Typography style={{ color: "#3d5afe" }}>
                          {foreclosureData.foreclosure.obj_total_floor === 0
                            ? "地坪:" + 0
                            : "地坪:" +
                              (
                                foreclosureData.foreclosure.obj_price /
                                foreclosureData.foreclosure.obj_total_floor
                              ).toFixed(2) +
                              "萬"}
                        </Typography>
                      </Box>
                      <Divider orientation="vertical" flexItem />
                      {"\u2002"}
                      <Box>
                        <Typography>
                          {foreclosureData.foreclosure.obj_land_data.replace(
                            /<br>/g,
                            ""
                          )}
                        </Typography>
                      </Box>
                    </Box>
                  </Grid>
                </CardContent>
                <Divider />
                <CardContent>
                  <Grid container spacing={1}>
                    <Box display="flex" alignItems="center" direction="row">
                      <Box minWidth="100px" maxWidth="100px">
                        <Typography>建物</Typography>
                        <Typography style={{ color: "#3d5afe" }}>{`公設比:${
                          Boolean(foreclosureData.foreclosure.obj_c_floor) &&
                          Boolean(foreclosureData.foreclosure.obj_total_floor)
                            ? (
                                (foreclosureData?.foreclosure.obj_c_floor /
                                  foreclosureData?.foreclosure
                                    .obj_total_floor) *
                                100
                              ).toFixed()
                            : 0
                        }%`}</Typography>
                      </Box>
                      <Divider orientation="vertical" flexItem />
                      {"\u2002"}
                      <Box>
                        <Typography>
                          {"\u2002" +
                            foreclosureData.foreclosure.obj_build_data.replace(
                              /<br>| /g,
                              ""
                            )}
                        </Typography>
                      </Box>
                    </Box>
                  </Grid>
                </CardContent>
                <Divider />
                <CardContent>
                  <Grid container spacing={1}>
                    <Box display="flex" alignItems="center" direction="row">
                      <Box minWidth={100}>
                        <Typography>公告筆錄</Typography>
                      </Box>
                      <Divider orientation="vertical" flexItem />
                      {"\u2002"}
                      <Box>
                        <Typography>
                          {foreclosureData.foreclosure.obj_bulletin_data.replace(
                            /<br>| /g,
                            ""
                          )}
                        </Typography>
                      </Box>
                    </Box>
                  </Grid>
                </CardContent>
              </>
            )}
          </Grid>
        </Grid>
      </Popper>
    );
  }
}
